import React from 'react';
import { Zap } from '../../../../shared/assets/AppIcons';
import { Button } from '@/shared/ui/button';
import { Card, CardContent } from '@/shared/ui/card';

export default function EmptyAutomationsState({ onDiscover }) {
  return (
    <Card className="border-[var(--border)]">
      <CardContent className="p-12 text-center">
        <Zap className="mx-auto text-[var(--text-secondary)] mb-4" size={32} />
        <h3 className="text-lg font-semibold text-[var(--text-primary)] mb-2">Nessuna automazione attiva</h3>
        <p className="text-[var(--text-secondary)] mb-4">
          Esplora le automazioni suggerite per iniziare a risparmiare tempo
        </p>
        <Button onClick={onDiscover} className="bg-[var(--warning)] hover:bg-[var(--warning)]">
          Scopri le Automazioni
        </Button>
      </CardContent>
    </Card>
  );
}
